// import CryptoJS from 'crypto-js';
import * as CryptoJS from 'crypto-js';


const secretKey: string  = "1235790qwertuop"; // Store it in an environment variable

if (!secretKey) {
  throw new Error('Encryption secret key not available.');
}

// Take an object and return encrypted data
export function encryptData(data: any): string {
  const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
  return encryptedData;
}

// Take encrypted data and return decrypted data
export function decryptData(encryptedData: string): any {
  if (encryptedData) {
    try {
      const newData = encryptedData.replaceAll('"', '');
      const decryptedBytes = CryptoJS.AES.decrypt(newData, secretKey);
      if (!decryptedBytes) {
        throw new Error('Decryption failed');
      }
      const decryptedData = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
      return decryptedData;
    } catch (error) {
      throw new Error('Decryption error: ' + (error as Error).message);
    }
  } else {
    throw new Error('Encrypted data not provided.');
  }
}
